import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./nav-dropdown.css";

const NavDropdownNav = (props) => {
  const [visible, setVisibility] = useState(false);

  return (
    <div
      id="nav-list-container"
      onMouseEnter={() => setVisibility(true)}
      onMouseLeave={() => setVisibility(false)}
    >
      <div id="nav-item-container">
        <h3>Navigate</h3>
        <MdKeyboardArrowDown className="arrow-down" />
      </div>
      {visible && (
        <div id="dropdown-list">
          <div>
            <Link to="/dashboard">
              <h3 className="nav-list-item">Dashboard</h3>
            </Link>
          </div>
          <div>
            <Link to="/dashboard/family">
              <h3 className="nav-list-item">Family</h3>
            </Link>
          </div>
          <div>
            <Link to="/dashboard/family/taskmanagment">
              <h3 className="nav-list-item">Tasks</h3>
            </Link>
          </div>
          {/* <div>
            <Link to="/dashboard/family/messages">
              <h3 className="nav-list-item">Messages</h3>
            </Link>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default NavDropdownNav;
